import { JSX } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

enum RootType {
  Tags = "Tags",
  ServiceAreas = "ServiceAreas"
}

const rootsToRender = ["Specialties"];

/** Renders the icon for a given root of a namespace path. */
function RootIcon(props: { root: string }): JSX.Element {
  let icon: JSX.Element;
  switch (props.root as RootType) {
    case RootType.ServiceAreas:
      icon = <QesIcon iconName={QesIcons.MarkerPinV6} isDecorative className="align-text-top mr10" />
      break;
    case RootType.Tags:
      icon = <QesIcon iconName={QesIcons.TagV1} description="Tag" className="align-text-top mr10" />
      break;
    default:
      icon = <QesIcon iconName={QesIcons.FilterLines} isDecorative className="align-text-top mr10" />
      break;
  }

  let rootString = "";
  if (rootsToRender.includes(props.root)) {
    rootString = props.root;
  }

  return (
    <>
      {icon}<span>{rootString}</span>
    </>
  );
}

export { RootIcon };
